import { render, staticRenderFns } from "./LessonDetail.vue?vue&type=template&id=c4e7bcda&scoped=true"
import script from "./LessonDetail.vue?vue&type=script&lang=js"
export * from "./LessonDetail.vue?vue&type=script&lang=js"
import style0 from "./LessonDetail.vue?vue&type=style&index=0&id=c4e7bcda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e7bcda",
  null
  
)

export default component.exports